/** Optional client-directory posture; never grants additional record access. */
export function clientRecordHref(id: string | number, fromClients: boolean): string {
  return `/leads/${id}${fromClients ? "?from=clients" : ""}`;
}

export function clientRecordContext(options: {
  enabled?: boolean;
  origin: string | null;
  referralPartner: boolean;
  staffLeadsHref: string;
  /** The person's list is /clients whichever list they arrived from. */
  clientsHome?: boolean;
}) {
  const fromClients = options.enabled === true && options.origin === "clients" && !options.referralPartner;
  const backToClients = fromClients || (options.clientsHome === true && !options.referralPartner);
  return {
    fromClients,
    backToClients,
    showUpdated: options.enabled !== true,
    backHref: options.referralPartner ? "/affiliator/patients" : backToClients ? "/clients" : options.staffLeadsHref,
  };
}
